<template>
  <div>
    <HttpContentView :endpoint="utilities.path('roles/@/users', roleId)" v-model:reload="reload">
      <template v-slot:content="{ data }">
        <div class="list-group">
          <div class="list-group-item" v-for="user in data" :key="user.id">
            <div class="d-flex align-items-center justify-content-between g-2">
              <UserView :user="user"/>
              <TargetedModalHttpFormView size="small" :endpoint="utilities.path('roles/@/users/@', roleId, user.id)" method="delete" @success="reload = true">
                <template v-slot:target="{ show }">
                  <ButtonView type="soft" color="danger" size="small" @click="show">
                    <i class="fas fa-trash"></i>
                  </ButtonView>
                </template>
                <template v-slot:form="{ submit, loading, hide }">
                  <SpinnerView :active="loading" color="danger"/>
                  <div class="d-flex align-items-center g-4">
                    <ButtonView type="normal" color="danger" class="w-100" @click="submit">
                      {{ translate("delete") }}
                    </ButtonView>
                    <ButtonView type="normal" color="secondary" class="w-100" @click="hide">
                      {{ translate("cancel") }}
                    </ButtonView>
                  </div>
                </template>
              </TargetedModalHttpFormView>
            </div>
          </div>
          <div class="list-group-item list-group-item-action" @click="creating = true">
            <div class="d-flex align-items-center justify-content-center">
              <i class="fas fa-plus text-primary"></i>
            </div>
          </div>
        </div>
      </template>
    </HttpContentView>
    <ModalHttpFormView :endpoint="utilities.path('roles/@/users', roleId)" method="post" v-model:active="creating" @success="reload = true">
      <template v-slot:form="{ content, errors, submit, loading }">
        <div class="d-flex flex-column g-4">
          <HttpContentView :endpoint="utilities.path('roles/@/users/addable', roleId)">
            <template v-slot:content="{ data }">
              <FilteredSelectInputView :options="data" :filter="({ query, item }) => item.name.toLowerCase().includes(query.toLowerCase())" v-model:value="content.userId" required :title="translate('user')" searchable :errors="errors.userId">
                <template v-slot:option="{ option }">
                  <UserView :user="option" style="pointer-events: none"/>
                </template>
              </FilteredSelectInputView>
            </template>
          </HttpContentView>
          <div class="d-flex align-items-center g-4">
            <ButtonView type="normal" color="primary" class="w-100" @click="submit">
              {{ translate("save") }}
            </ButtonView>
            <ButtonView type="normal" color="secondary" class="w-100" @click="creating = false; editing = undefined">
              {{ translate("cancel") }}
            </ButtonView>
          </div>
          <SpinnerView :active="loading" color="primary"/>
        </div>
      </template>
    </ModalHttpFormView>
  </div>
</template>

<script setup>
import {HttpContentView, utilities, TargetedModalHttpFormView, ButtonView, SpinnerView, ModalHttpFormView, FilteredSelectInputView} from "@/niftybit";
import {ref} from "vue";
import UserView from "@/components/other/UserView.vue";

defineProps({
  roleId: String
});

const reload = ref(false);
const creating = ref(false);

</script>